import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PortForm from 'components/PortForm';
import PortResponse from 'components/PortResponse';
import SubNav from 'components/SubNav';
import { updatePort } from 'actions/subs';
import { getPortResponse, getSubmitStatus } from 'reducers';
import subPage from 'decorators/subPage';
import injectPreactivation from 'decorators/injectPreactivation';

let NewPort = ({
  subId,
  sub,
  user,
  preactivationId,
  preactivation,
  values,
  updatePort,
  portResponse,
  ...props
}) => {
  if (!sub || !user || (preactivationId && !preactivation)) {
    return <div>Loading</div>;
  }
  if (portResponse && portResponse.valid) {
    return (
      <div>
        <PortResponse data={portResponse} />
        <div>
          <Link to={`/subscriptions/${subId}/update-port`}>Update Port</Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1>New Port</h1>
      <SubNav />
      <br />
      <PortForm
        initialValues={values}
        onSubmit={(values) => updatePort(subId, values)}
        {...props}
      />
      <br />
      {portResponse && <PortResponse data={portResponse} />}
    </div>
  );
};

const mapModelsToValues = (
  { first_name, last_name },
  { address },
  preactivation,
) => {
  const {
    address1: street,
    city,
    state,
    zip_code,
  } = address && address.length > 0 && address[0];

  return {
    mdn: preactivation && preactivation.mdn,
    port_details: {
      account: preactivation && preactivation.old_account_number,
      pin: preactivation && preactivation.old_pin,
      authorized_by: `${first_name} ${last_name}`,
      first_name,
      last_name,
      street,
      city,
      state,
      zip_code,
    },
  };
};

const mapStateToProps = (state, { subId, sub, user, preactivation }) => ({
  portResponse: getPortResponse(state, subId),
  saveStatus: getSubmitStatus(state, 'port'),
  values: sub && user && mapModelsToValues(sub, user, preactivation),
});

const mapDispatchToProps = {
  updatePort,
};

NewPort = compose(
  subPage,
  injectPreactivation,
  connect(mapStateToProps, mapDispatchToProps),
)(NewPort);

export default NewPort;
